<template>
  <div>
    <div class="row mb-4 mt-1" v-for="i in count" :key="i">
      <div class="col-md-5 px-md-3 px-0">
        <b-skeleton height="220px"></b-skeleton>
      </div>
      <div class="col-md-7 d-md-block d-none">
        <div class="row">
          <div class="col-3">
            <b-skeleton height="18px"></b-skeleton>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col-5">
            <b-skeleton height="30px"></b-skeleton>
          </div>
          <div class="col-3">
            <b-skeleton height="18px"></b-skeleton>
          </div>
          <div class="col-4">
            <div class="d-flex justify-content-between">
              <div class="w-100 mr-4">
                <b-skeleton height="18px" width="100%"></b-skeleton>
                <b-skeleton height="18px" width="90%"></b-skeleton>
              </div>
              <b-skeleton height="36px" width="70px"></b-skeleton>
            </div>
          </div>
        </div>
        <b-skeleton height="18px" width="60%" class="mt-2"></b-skeleton>
        <b-skeleton height="18px" width="40%" class="mt-2"></b-skeleton>
        <b-skeleton height="50px" class="my-2"></b-skeleton>
        <div class="d-flex justify-content-between align-items-center">
          <b-skeleton height="25px" width="150px"></b-skeleton>
          <b-skeleton height="35px" width="150px"></b-skeleton>
        </div>
      </div>
      <div class="col-12 d-md-none d-block px-0">
        <div class="d-flex align-items-center mt-3">
          <b-skeleton height="20px" width="50%"></b-skeleton>
          <b-skeleton height="20px" class="ml-3" width="25%"></b-skeleton>
        </div>
        <div class="my-2">
          <b-skeleton height="12px"></b-skeleton>
          <b-skeleton height="8px"></b-skeleton>
        </div>
        <div class="my-2" style="width: 50%">
          <div class="d-flex">
            <div style="width: 60%;" class="mr-2">
                <b-skeleton height="20px"></b-skeleton>
                <b-skeleton height="10px"></b-skeleton>
            </div>
            <b-skeleton height="35px" width="30%"></b-skeleton>
          </div>
        </div>
        <b-skeleton height="40px"></b-skeleton>
        <div class="d-flex align-items-end justify-content-between mt-2">
          <b-skeleton height="20px" width="40%"></b-skeleton>
          <b-skeleton height="30px" width="30%"></b-skeleton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ListingSkeleton",
  props: {
    count: {
      type: Number,
      default: 10,
    },
  },
};
</script>
